var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "group shadow mb-6 cursor-pointer text-grey-darkest leading-normal rounded",
          on: { click: _vm.handleClick }
        },
        [
          _c(
            "div",
            { staticClass: "flex items-top p-3 md:p-6 bg-white rounded-t" },
            [
              _c("avatar", {
                staticClass: "mr-2 w-10 h-10 md:w-12 md:h-12",
                attrs: {
                  avatar: _vm.item.doctorAvatar,
                  name: _vm.item.doctorFirstName + " " + _vm.item.doctorLastName
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ml-4" },
                [
                  _c("div", { staticClass: "flex items-center md:mt-1" }, [
                    _c("span", { staticClass: "text-sm font-bold" }, [
                      _vm._v(
                        _vm._s(
                          _vm.item.doctorFirstName +
                            " " +
                            _vm.item.doctorLastName
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex items-center" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "text-sm text-grey font-semi-bold" },
                      [
                        _vm._v(
                          _vm._s(_vm.item.officeZipCode) +
                            " " +
                            _vm._s(_vm.item.officeLocality)
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.item.foundOffice &&
                  _vm.item.foundOffice.isDoctorMemberOfOsteopathie
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "tooltip text-green font-semibold text-sm mt-1 mb-2"
                        },
                        [
                          _c("i", { staticClass: "mdi mdi-check-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("Member_of_Osteopathie")) +
                              "\n                    "
                          ),
                          _c("span", { staticClass: "tooltip-text text-sm" }, [
                            _vm._v(_vm._s(_vm.$t("Oste_tooltip")))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex mb-1" },
                    [
                      _vm.item.isDoctorRegulated &&
                      (_vm.item.type !== "OSTEOPATH" &&
                        _vm.item.type !== "PSYCHOLOGIST")
                        ? [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-sm text-green" }, [
                              _vm._v(_vm._s(_vm.$t("Contracted_doctor")))
                            ])
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.item.isDoctorRegulated &&
                      (_vm.item.type !== "OSTEOPATH" &&
                        _vm.item.type !== "PSYCHOLOGIST")
                        ? [
                            _vm._m(2),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-sm text-red" }, [
                              _vm._v(
                                _vm._s(_vm.$t("Contracted_doctor_negative"))
                              )
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.item.foundOffice && _vm.item.foundOffice.officeSettings
                    ? _c("OfficeSettings", {
                        attrs: {
                          accessible:
                            _vm.item.foundOffice.officeSettings.accessible,
                          card: _vm.item.foundOffice.officeSettings.card,
                          cash: _vm.item.foundOffice.officeSettings.cash
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.sortedSlots, function(slot, index) {
                    return _c(
                      "div",
                      {
                        key: slot.id,
                        staticClass: "flex items-center md:mt-1"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "icon mr-2 text-lg",
                            class:
                              index == 0 ? "text-grey-darkest" : "text-white"
                          },
                          [_c("i", { staticClass: "mdi mdi-calendar-check" })]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-sm md:text-base" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("momentFormat")(
                                slot.date,
                                "YYYY-MM-DD",
                                _vm.$t("date_selector_format")
                              )
                            ) +
                              " " +
                              _vm._s(_vm.$t("at")) +
                              " " +
                              _vm._s(
                                _vm._f("momentFormatTime")(
                                  slot.time,
                                  _vm.$t("time_format")
                                )
                              )
                          )
                        ])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.sortedSlots.length < _vm.item.timeslots.length
                    ? _c("div", { staticClass: "flex items-center md:mt-1" }, [
                        _vm._m(3),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "text-sm md:text-base text-grey-dark"
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("x_more_availabilities", {
                                  count:
                                    _vm.item.timeslots.length -
                                    _vm.sortedSlots.length
                                })
                              )
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "transition flex rounded-b bg-grey-light group-hover:bg-blue text-grey-darker group-hover:text-white py-1 justify-center"
            },
            [
              _c(
                "span",
                {
                  staticClass: "uppercase tracking-wide font-semibold text-sm"
                },
                [_vm._v(_vm._s(_vm.$t("Detail_of_the_appointment")))]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("timeslot-selection-modal", {
        attrs: { active: _vm.showTimeslotSelection, group: _vm.item },
        on: { close: _vm.hideTimeslotSelectionModal }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-sm text-grey" }, [
      _c("i", { staticClass: "mdi mdi-map-marker" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-sm text-green" }, [
      _c("i", { staticClass: "mdi mdi-currency-eur" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-sm text-red" }, [
      _c("i", { staticClass: "mdi mdi-currency-eur" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-lg text-white" }, [
      _c("i", { staticClass: "mdi mdi-calendar-check" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ff6f4a8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff6f4a8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Patient/TimeslotGroupListItem.vue
// module id = 760
// module chunks = 1